export default __webpack_public_path__ + "static/media/480_dummy2016-nagelstudio01-mobile-de.610ce016.png";